
export const Base_url = "https://backend.esgbites.com";
export const frontEnd_url = "https://esg-bites.netlify.app";
